import { HttpClient } from '../utils/httpClient';

const PATH = {
    events: '/client/bess/events',
    currentEvents: '/client/bess/current-events',
    logs: '/client/bess/event-logs',
    commandLogs: '/client/bess/command-logs',
    dataLog: '/client/bess/data-log'
};

const GetEvents = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.events}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetCurrentEvents = (start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.currentEvents}`).then(callback).catch(error).finally(next);
};

const GetLogs = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.logs}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetCommandLogs = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.commandLogs}/${id}`).then(callback).catch(error).finally(next);
};

const GetDataLog = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.dataLog}`, { params }).then(callback).catch(error).finally(next);
};

export const EventsService = {
    GetEvents,
    GetCurrentEvents,
    GetLogs,
    GetCommandLogs,
    GetDataLog
};
